import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

export default function BrandHighlightsEndorsementsForm({
  form,
  isDetail = false,
  name = "endorsement",
}: {
  form: any;
  isDetail?: boolean;
  name: string | string[];
}) {
  const { t } = useTranslation();
  const { TextArea } = Input;
  return (
    <div
      className={`flex flex-col gap-4 ${
        isDetail ? "bg-transparent" : "p-6 bg-white rounded-[16px] mb-4 "
      }`}
    >
      <div className="flex flex-col gap-2">
        <div
          className={`justify-start text-text-color-primary leading-8 ${
            isDetail
              ? "text-sm font-medium"
              : "text-xl font-semibold font-['DM_Sans']"
          }`}
        >
          {t("campaignCreate.businessInformation.brandHighlightsEndorsements", {
            defaultValue: "Brand highlights & endorsements",
          })}
        </div>
        <div className="self-stretch justify-start text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-5">
          {t("campaignCreate.businessInformation.endorsementPlaceholderDesc", {
            defaultValue:
              "Add highlights that boost influencer trust and increase collaboration rates.",
          })}
        </div>
      </div>
      <Form.Item name={name} className="mb-0">
        <TextArea
          placeholder={t(
            "campaignCreate.businessInformation.endorsementPlaceholder",
            {
              defaultValue: "e.g., funding, major partners, traction, revenue...",
            }
          )}
          size="large"
          autoSize={{ minRows: 3, maxRows: 5 }}
          maxLength={200}
          showCount
        />
      </Form.Item>
    </div>
  );
}
